import { render, staticRenderFns } from "./TyreGrid.vue?vue&type=template&id=5396ab92&scoped=true&"
import script from "./TyreGrid.vue?vue&type=script&lang=js&"
export * from "./TyreGrid.vue?vue&type=script&lang=js&"
import style0 from "./TyreGrid.vue?vue&type=style&index=0&id=5396ab92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5396ab92",
  null
  
)

export default component.exports